import { getDashboardService } from "@ntconnect/framework/pbx";

export const fetchStatistics = (domain) =>
  getDashboardService().fetchStatistics(domain);
